import { z } from 'zod';

const decimal = z.string().regex(/^-?\d+(\.\d+)?$/);
export const RevenueTransactionSchema = z.object({
  type: z.enum(['payment', 'incoming', 'conversion']),
  id: z.string(),
  client_id: z.string(),
  client_name: z.string(),
  created_at: z.string().datetime({ offset: true }),
  transaction_id: z.string().nullable(),
  transaction_cod: z.string().nullable(),
  amount: decimal,
  currency_code: z.string(),
  revenue: decimal,
  revenue_currency: z.string(),
  buy_amount: decimal.nullable(),
  buy_currency: z.string().nullable(),
  status: z.enum(['processing', 'completed']),
});
export const RevenueTransactionsSchema = z.object({
  items: z.array(RevenueTransactionSchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  page_size: z.number().int().positive(),
  total_pages: z.number().int().nonnegative(),
});
export type RevenueTransaction = z.infer<typeof RevenueTransactionSchema>;

/** Group digits without converting monetary strings to floating point. */
export function formatRevenueAmount(value: string): string {
  const [whole, fraction = ''] = value.split('.');
  const digits = fraction.replace(/0+$/, '').padEnd(2, '0');
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${digits}`;
}
